<template>
  <div></div>
  <!--
  <footer class="footer px-4 mx-2">
    <b-row align-v="center" class="justify-content-lg-between"> </b-row>
  </footer>
  -->
</template>

<style></style>

<script>
export default {
  data() {
    return { year: new Date().getFullYear() };
  }
};
</script>
